export const TOKEN_KET = 'token'

export const STREAM_STATE = {
  UNDEFINED: 'undefined',
  ONLINE: 'online',
  OFFLINE: 'offline'
}
